
<div>
  <b-modal
    ref="taskdetail"
    id="taskdetail"
    @hidden="modalClosed"
    hide-footer
    hide-header
    :size="getModalSize"
    :title="item.title"
    :no-close-on-backdrop="noCloseOnBackdrop"
    body-class="modal-body-wo"
    @hide="modalHiding"
  >
    <div :class="{ 'archived-bi-details': readOnly }">
      <h2 v-if="readOnly" :class="{ 'striped-header': readOnly }">
        <span v-if="item.isReadonly">Readonly</span>
        <span v-if="item.isArchived">Archived</span>
      </h2>

      <div>
        <ValidationObserver tag="form" ref="form" @submit.stop.prevent="() => {}" v-slot="{ invalid }">
          <div v-if="loading">
            <div class="d-flex align-items-center justify-content-center p-5">
              <loading-spinner></loading-spinner>
            </div>
          </div>
          <modal-window v-if="!loading" class="taskdetail" :main-width="9" @dragenter="dragEnter" @dragleave="dragLeave">
            <div>
              <ValidationProvider name="BoardItemTitle" rules="required" v-slot="{ errors }">
                <h1>
                  <textarea-autosize
                    class="area task-title"
                    rows="1"
                    v-on:keydown.enter.native="$event.target.blur()"
                    v-model="item.title"
                    ref="title"
                    placeholder="Click here to enter the title"
                    :min-height="20"
                    v-on:blur.native="autoSaveDelayed"
                    :disabled="readOnly"
                  />
                </h1>
                <div v-if="errors[0]" class="board-item-title-error alert alert-danger" role="alert">Title is required</div>
              </ValidationProvider>

              <div v-if="item.isSystemGenerated" class="label">Generated by System</div>

              <BoardItemLabels :item="item" :isEditable="!readOnly" />

              <div class="label mt-3 mb-1">Task Category / Type</div>

              <ValidationProvider name="BoardItemCategory" rules="required" v-slot="{ errors }">
                <grouped-select
                  :options="availableBoardCategories"
                  v-model="item.boardItemTypeId"
                  :disabled="item.isSystemGenerated || readOnly"
                ></grouped-select>

                <div v-if="errors[0]" class="alert alert-danger" role="alert">Category / Type is required</div>
              </ValidationProvider>

              <BoardItemConnections :boardItem="item" v-if="!item.isTemplate"></BoardItemConnections>

              <div class="label mt-4 mb-1">
                Description
                <i class="far fa-pencil" v-if="!readOnly" @click="startEditDescription()"></i>
              </div>

              <div class="description" v-if="!editdescription" v-html="linkifiedDescription" @click="startEditDescription"></div>

              <div class="description" v-if="!item.description && !editdescription" @click="startEditDescription()">No description</div>

              <ValidationProvider name="BoardItemDescription">
                <wysiwig-editor
                  :simple-mode="!item.isTemplate"
                  ref="editor"
                  v-show="editdescription"
                  v-model="item.description"
                  v-on:imagepasted="imagePasted"
                  v-on:blur="leaveDescription('blur')"
                ></wysiwig-editor>
                <div class="d-flex justify-content-end" v-if="editdescription">
                  <button class="btn btn-sm btn-success mt-2" @click="leaveDescription('click')">
                    <i class="far fa-save"></i>
                    Save description
                  </button>
                </div>
              </ValidationProvider>

              <div class="mt-4 mb-1" v-if="item.spreadsheetData || showBoardItemSpreadsheet">
                <BoardItemSpreadsheet
                  :json="item.spreadsheetData"
                  :sheet-name="'Flight Changes'"
                  @modelUpdate="processSpreadsheetUpdate"
                  @spreadsheetDelete="processSpreadsheetDelete"
                />
              </div>

              <!-- <BoardItemDelayInfo /> -->

              <WideAttachments :boardItem="item" />

              <!-- Checklist section -->
              <Checklist :item="item" :isTemplate="item.isTemplate" :readOnly="readOnly"></Checklist>

              <div v-if="showAttachmentsSection">
                <AttachmentView
                  :destinationId="item.id"
                  :destination="'BoardItem'"
                  :attachments="orderedAttachments"
                  :readOnly="readOnly"
                  :ignore-file-extensions="'eml'"
                />

                <AttachmentView
                  :destinationId="item.id"
                  :destination="'BoardItem'"
                  :attachments="orderedAttachments"
                  :readOnly="readOnly"
                  :header="'Sent and received Emails'"
                  :fileExtensions="'eml'"
                  :disable-download-all="true"
                />
              </div>

              <div v-if="!item.isTemplate && item.actions && item.actions.length">
                <BoardItemActions :item="item"></BoardItemActions>
              </div>

              <div v-if="item.isTemplate" class="w-100">
                <div class="label mt-2 mb-1">Actions</div>
                <p>Optional - Please refer to documentation for format</p>

                <ValidationProvider name="BoardItemActionsJson">
                  <v-jsoneditor v-model="actionsTemplateObj" :options="jsonEditorOptions" inputmode="code" height="400px"></v-jsoneditor>
                </ValidationProvider>
              </div>

              <div v-if="item.isTemplate" class="w-100 mt-4">
                <div class="label mt-2 mb-1">Dynamic files</div>
                <p>Optional - Please refer to documentation for format</p>

                <ValidationProvider name="BoardItemDynamicTemplateFiles">
                  <v-jsoneditor
                    v-model="dynamicTemplateFilesObj"
                    :options="jsonEditorOptions"
                    inputmode="code"
                    height="200px"
                  ></v-jsoneditor>
                </ValidationProvider>
              </div>
            </div>

            <task-detail-comments v-model="commentIsDirty"></task-detail-comments>

            <template v-slot:dropzone>
              <!-- Dropzone for File attachments -->
              <div
                v-if="draggedOver"
                class="dropzone w-100 d-flex flex-col align-items-center justify-content-center"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 100"
                :class="{ 'dropzone-dragged': dragOverDropzone }"
                @drop.prevent="dropDropzone"
                @dragenter.prevent="dragEnterDropzone"
                @dragleave.prevent="dragLeaveDropzone"
                @dragend.prevent
                @dragover.prevent
              >
                <div
                  class="text-2xl font-weight-bold drop-zone-text"
                  style="color: #888"
                  @drop.prevent="dropDropzone"
                  @dragenter.prevent="dragEnterDropzone"
                  @dragleave.prevent="dragLeaveDropzone"
                  @dragend.prevent
                  @dragover.prevent
                >
                  <i class="far fa-spinner fa-spin" v-if="fileIsUploading"></i>
                  Drop file here
                </div>
              </div>
            </template>

            <template v-slot:sidebar>
              <div class="bi-sidebar">
                <BoardItemStatus :status="item.boardItemStatus" size="xl" v-if="!item.isTemplate"></BoardItemStatus>

                <board-item-date
                  v-if="!item.isTemplate"
                  :disabled="readOnly"
                  :displayPlannedDate="currentBoardShiftsState"
                  :boardItem="item"
                  v-on:boardItemDateUpdated="processBoardItemDateUpdates"
                  v-on:opened="noCloseOnBackdrop = true"
                  v-on:closed="noCloseOnBackdrop = false"
                ></board-item-date>

                <BoardItemAssignedUser
                  v-if="!item.isTemplate"
                  v-model="item.assignedToUser"
                  :disabled="readOnly"
                  v-on:boardItemAssignedUserUpdated="processAssignedUserUpdates"
                ></BoardItemAssignedUser>

                <div class="label mt-2 mb-1">Status</div>

                <div>
                  <ToggleSwitch
                    label="High Priority"
                    :value="item.priority == 'High'"
                    :color="toggleSwitchColors.red"
                    @update="(update) => processPriorityChange(update)"
                  />

                  <ToggleSwitch
                    label="Relevant for Report"
                    v-model="item.isRelevantForReport"
                    :color="toggleSwitchColors.blue"
                    @update="(update) => processIsRelevantForReportChange(update)"
                  />
                  <ToggleSwitch
                    label="Task is confidential"
                    v-model="item.isConfidential"
                    :color="toggleSwitchColors.blue"
                    @update="(update) => processIsConfidentialChange(update)"
                  />
                </div>

                <div class="mt-3" v-if="item.specialOccurrenceId && item.id">
                  <div class="label">Special Occurrence</div>
                  <div class="d-flex justify-content-between">
                    <div class="badge so-badge" :class="occurrenceClass">
                      <router-link
                        :to="{
                          name: getTechnicalOccurrenceRouteName(),
                          params: { occId: item.specialOccurrenceId },
                        }"
                      >
                        {{ item.specialOccurrenceName }}
                      </router-link>
                    </div>
                    <i
                      v-if="item.specialOccurrenceCouldBeUnlinked && !readOnly"
                      class="far fa-trash-alt cursor-pointer so-remove"
                      v-on:click="moveBoardItemFromOccurrence(item.id)"
                    ></i>
                  </div>
                </div>

                <!-- Add Section -->
                <div v-if="item.id && !readOnly">
                  <div class="label mt-4 mb-1">Add</div>

                  <AddLabels :item="item" />

                  <UploadAttachment :destination="'BoardItem'" :destinationId="item.id" />

                  <!-- Create Checklist -->
                  <AddChecklist :item="item"></AddChecklist>

                  <div class="mt-2">
                    <button class="btn btn-block btn-info" id="send-email" @click="addSpreadSheet()">
                      <i class="far fa-file-excel icon-left"></i>
                      Spreadsheet
                    </button>
                  </div>

                  <!-- Special Occurrence -->
                  <div
                    class="mt-2"
                    v-b-tooltip.hover.right
                    :title="item.id ? '' : 'Please save this task, before linking it to Special Occurrence'"
                    v-if="anyOccurreceIsAvailable && !item.specialOccurrenceId && !item.isTemplate"
                  >
                    <button :disabled="!item.id || readOnly" class="btn btn-block btn-info" id="link-to-so" @click="soSearch = ''">
                      <i class="far fa-star-exclamation icon-left"></i>
                      Special Occurrence
                    </button>

                    <b-popover ref="link-to-so" target="link-to-so" triggers="click blur" custom-class="so-popover">
                      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Special Occurrence</div>
                      <div>
                        <input type="text" v-model="soSearch" class="form-control" placeholder="Search..." aria-label="soSearch" />
                      </div>

                      <div class="label mt-2 mb-1 d-flex align-items-center justify-content-center">Active Special Occurrences</div>
                      <hr class="mt-2" />

                      <div v-if="filteredActiveOccurrences.length">
                        <div v-for="occ in filteredActiveOccurrences" :key="occ.id" class="bi-popover-item">
                          <button class="btn btn-block btn-info" @click="linkBoardItem(occ)">
                            {{ occ.name }}
                          </button>
                        </div>
                      </div>
                      <div v-else class="label mt-1 mb-1 d-flex align-items-center justify-content-center">
                        No Active Occurrences available
                      </div>

                      <hr class="mt-3" />
                      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Archived Special Occurrences</div>
                      <hr class="mt-2" />

                      <div v-if="filteredArchivedOccurrences.length">
                        <div v-for="occ in filteredArchivedOccurrences" :key="occ.id" class="bi-popover-item">
                          <button class="btn btn-block btn-info" @click="linkBoardItem(occ)">
                            {{ occ.name }}
                          </button>
                        </div>
                      </div>
                      <div v-else class="label mt-1 mb-1 d-flex align-items-center justify-content-center">
                        No Archived Occurrences available
                      </div>
                    </b-popover>
                  </div>
                  <!-- Special Occurrence End-->

                  <!-- Template Pre-Sharing -->
                  <!-- <div v-if="item.isTemplate && item.isWideItem" class="mt-2" v-b-tooltip.hover.right>
                    <button class="btn btn-block btn-info" id="template-share-with">
                      <i class="far fa-share icon-left"></i>
                      <span v-if="!item.isShared">Share task</span>
                      <span v-else>Share settings</span>
                    </button>

                    <b-popover ref="template-shareWith" target="template-share-with" triggers="click blur">
                      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center" v-if="boardsToShare.length">
                        Share with...
                      </div>
                      <div v-for="board in boardsToShare" :key="board.id" class="bi-popover-item">
                        <button class="btn btn-block btn-info d-flex align-items-center" @click="shareWith(board, true)">
                          <i class="far fa-plus-circle mr-2"></i>
                          {{ board.title }}
                        </button>
                      </div>

                      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center" v-if="sharedBoards.length">
                        Shared with...
                      </div>
                      <div v-for="board in sharedBoards" :key="board.id" class="bi-popover-item">
                        <button class="btn btn-block btn-success d-flex align-items-center" @click="unshare(board, true)">
                          <i class="far fa-minus-circle mr-2"></i>
                          {{ board.title }}
                        </button>
                      </div>
                    </b-popover>
                  </div> -->
                  <!-- Template Pre-Sharing End-->
                </div>

                <!--Collaboration Start-->
                <div v-if="item.id && !item.isTemplate && !readOnly">
                  <div class="label mt-4 mb-1 d-flex justify-content-between">
                    <span>Collaboration</span>
                  </div>

                  <div class="mt-2">
                    <button class="btn btn-block btn-info" id="send-email" @click="openSendAsEmail()">
                      <i class="far fa-envelope icon-left"></i>
                      Send as email
                    </button>
                  </div>

                  <!-- Share with -->
                  <div
                    class="mt-2"
                    v-b-tooltip.hover.right
                    :title="item.id ? '' : 'Please save this task, before sharing it with another board'"
                    v-if="allBoardsExceptCurrent.length && !item.isDelegated && !item.isConfidential"
                  >
                    <button :disabled="!item.id" class="btn btn-block btn-info" id="share-with">
                      <i class="far fa-share icon-left"></i>
                      <span v-if="!item.isShared">Share task</span>
                      <span v-if="item.isShared">Share settings</span>
                    </button>

                    <b-popover ref="shareWith" target="share-with" triggers="click blur">
                      
                      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center" v-if="boardsToShare.length">
                        Share with...
                      </div>
                      <div v-for="board in boardsToShare" :key="board.id" class="bi-popover-item">
                        <button class="btn btn-block btn-info d-flex align-items-center" @click="shareWith(board)">
                          <i class="far fa-plus-circle mr-2"></i>
                          {{ board.title }}
                        </button>
                      </div>

                      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center" v-if="sharedBoards.length">
                        Shared with...
                      </div>
                      <div v-for="board in sharedBoards" :key="board.id" class="bi-popover-item">
                        <button class="btn btn-block btn-success d-flex align-items-center" @click="unshare(board)">
                          <i class="far fa-minus-circle mr-2"></i>
                          {{ board.title }}
                        </button>
                      </div>

                      <template v-if="item.isShared">
                        <button class="btn btn-block btn-danger d-flex align-items-center" @click="leaveSharedItem">
                          <i class="far fa-minus-circle mr-2"></i>
                          Remove {{ currentBoardName }} from shared task
                        </button>

                        <button
                          class="btn btn-block btn-danger d-flex align-items-center"
                          @click="stopSharing"
                          v-b-tooltip.bottom="'Terminates sharing and moves the task to your current board to the Tasks column'"
                        >
                          <i class="far fa-minus-circle mr-2"></i>
                          End (terminate) task sharing
                        </button>
                      </template>
                    </b-popover>
                  </div>

                  <!-- Move to -->
                  <div
                    class="mt-2"
                    v-b-tooltip.hover.right
                    :title="item.id ? '' : 'Please save this task, before moving it to another board'"
                    v-if="allBoardsExceptCurrent.length && !item.isDelegated && !item.isShared && !item.isConfidential"
                  >
                    <button :disabled="!item.id" class="btn btn-block btn-info" id="move-to">
                      <i class="far fa-share icon-left"></i>
                      Move to
                    </button>

                    <b-popover ref="moveTo" target="move-to" triggers="click blur">
                      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Move to...</div>

                      <div v-for="board in allBoardsExceptCurrent" :key="board.id" class="bi-popover-item">
                        <button class="btn btn-block btn-info" @click="moveTo(board)">
                          {{ board.title }}
                        </button>
                      </div>
                    </b-popover>
                  </div>

                  <!-- Delegate to -->
                  <div
                    class="mt-2"
                    v-b-tooltip.hover.right
                    :title="item.id ? '' : 'Please save this task, before delegating it to another board'"
                    v-if="allBoardsExceptCurrent.length && !item.isDelegated && !item.isShared && !item.isConfidential"
                  >
                    <button :disabled="!item.id" class="btn btn-block btn-info" id="delegate-to">
                      <i class="far fa-share icon-left"></i>
                      Delegate to
                    </button>

                    <b-popover ref="delegateTo" target="delegate-to" triggers="click blur">
                      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Delegate to...</div>

                      <div v-for="board in allBoardsExceptCurrent" :key="board.id" class="bi-popover-item">
                        <button class="btn btn-block btn-info" @click="delegate(board)">
                          {{ board.title }}
                        </button>
                      </div>
                    </b-popover>
                  </div>

                  <!-- Reject / Give Back -->
                  <div v-if="item.isDelegated && item.ownerBoardId !== boardStore.currentBoardId">
                    <div class="mt-2">
                      <button class="btn btn-block btn-info" @click="giveBackDelegatedBoardItem()">
                        <i class="fas fa-share icon-left"></i>
                        Reject / Give Back
                      </button>
                    </div>
                  </div>

                  <!-- Take Back -->
                  <div
                    v-if="
                      item.isDelegated && item.ownerBoardId === boardStore.currentBoardId && item.boardItemStatus === itemStatus.Planned
                    "
                  >
                    <div class="mt-2">
                      <button class="btn btn-block btn-info" @click="takeBackDelegatedBoardItem()">
                        <i class="fas fa-share icon-left"></i>
                        Take Back
                      </button>
                    </div>
                  </div>
                </div>

                <BoardItemAcceptReject :item="item" :view="acceptRejectView.Vertical"></BoardItemAcceptReject>

                <template v-if="!readOnly">
                  <button
                    v-if="item.id && !item.isTemplate"
                    class="mt-2 btn btn-block btn-info"
                    id="toggle-watch"
                    @click="toggleSubscription()"
                  >
                    <i
                      class="far icon-left"
                      :class="{ 'fa-eye-slash': item.currentUserIsSubscribed, 'fa-eye': !item.currentUserIsSubscribed }"
                    ></i>
                    <span v-if="item.currentUserIsSubscribed">Unsubscribe</span>
                    <span v-else>Subscribe</span>
                  </button>
                </template>

                <!--Collaboration End -->

                <!-- Board Item report   -->
                <button
                  class="mt-4 btn btn-block btn-info"
                  v-if="!item.attachments?.length && item.id"
                  :disabled="pdfIsLoading"
                  @click="getBoardItemReport()"
                >
                  <i v-if="!pdfIsLoading" class="far fa-file-pdf icon-left"></i>
                  <i v-else class="far fa-spinner fa-spin icon-left"></i>
                  Generate Report
                </button>

                <button
                  class="mt-2 btn btn-block btn-info"
                  v-show="item.attachments?.length && item.id"
                  id="generate-report"
                  :disabled="pdfIsLoading"
                >
                  <i v-if="!pdfIsLoading" class="far fa-file-pdf icon-left"></i>
                  <i v-else class="far fa-spinner fa-spin icon-left"></i>
                  Generate Report
                </button>

                <div v-if="item.id" class="mt-2" v-b-tooltip.hover.right>
                  <button class="btn btn-block btn-info" id="bi-advanced-actions">
                    <i class="far fa-share icon-left"></i>
                    Advanced
                  </button>

                  <b-popover ref="bi-advanced-actions" target="bi-advanced-actions" triggers="click blur">
                    <button
                      class="mt-2 btn btn-block btn-info bi-popover-item"
                      v-if="currentUserIsBoardAdmin && !item.isTemplate"
                      @click="createTemplateFromBoardItem"
                    >
                      <i class="far fa-star-exclamation icon-left"></i>
                      Create Template from Task
                    </button>

                    <button
                      v-if="item.id && !item.isTemplate"
                      class="mt-2 btn btn-block btn-info bi-popover-item"
                      id="toggle-watch"
                      @click="toggleAutomaticStatusChangeOnShiftHandover()"
                    >
                      <i class="far icon-left fa-cog mr-1"></i>
                      <span v-if="item.enableAutomaticStatusChangeOnShiftHandover">Auto-Status change: ON</span>
                      <span v-else>Auto-Status change: OFF</span>
                      <i
                        class="ml-2 far fa-info-circle"
                        v-b-tooltip="
                          'Toggle if this task will be automatically moved to the Tasks list on Shift Handover if it is still in progress'
                        "
                      ></i>
                    </button>

                    <BoardItemHistory :boardItem="item" v-if="!item.isTemplate" class="bi-popover-item"></BoardItemHistory>
                  </b-popover>
                </div>

                <b-popover ref="generateReportPopover" target="generate-report" triggers="click blur">
                  <button class="btn btn-block btn-info d-flex align-items-center" :disabled="pdfIsLoading" @click="getBoardItemReport()">
                    <i v-if="!pdfIsLoading" class="far fa-file-pdf mr-2"></i>
                    <i v-else class="far fa-spinner fa-spin mr-2"></i>
                    PDF only
                  </button>

                  <button
                    class="btn btn-block btn-info d-flex align-items-center"
                    :disabled="pdfIsLoading"
                    @click="getBoardItemReport(true)"
                  >
                    <i v-if="!pdfIsLoading" class="far fa-file-pdf mr-2"></i>
                    <i v-else class="far fa-spinner fa-spin mr-2"></i>
                    ZIP with PDF and Attachments
                  </button>
                </b-popover>

                <!-- Save new BoardItem -->
                <div v-if="!item.id">
                  <div class="label mt-4 mb-1">Save new Task</div>
                  <div class="label mb-2">
                    <button
                      class="btn btn-block btn-sm btn-success"
                      :disabled="isSaving || !item.boardItemTypeId || !item.title"
                      @click="
                        isSaving = true;
                        addNewBoardItemAndOpen();
                      "
                    >
                      <i class="far fa-save"></i>
                      Save changes
                    </button>
                  </div>
                  <div class="label mb-2">
                    <button class="btn btn-block btn-sm btn-primary" @click="addNewBoardItemAndClose()" :disabled="invalid || !isDirty">
                      <i class="far fa-save"></i>
                      Save and close
                    </button>
                  </div>
                </div>

                <!-- Update BoardItem -->
                <div v-if="item.id && !readOnly" class="mt-4">
                  <div class="label mb-2">
                    <button class="btn btn-block btn-sm btn-success" @click="saveChanges()" :disabled="invalid || !isDirty">
                      <i class="far fa-save"></i>
                      Save changes
                    </button>
                  </div>

                  <div class="label mb-2">
                    <button class="btn btn-block btn-sm btn-primary" @click="saveChangesAndClose()" :disabled="invalid || !isDirty">
                      <i class="far fa-save"></i>
                      Save and close
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </modal-window>
        </ValidationObserver>
      </div>
    </div>
  </b-modal>

  <b-modal ref="unsavedValidModal" hide-footer body-class="modal-body-wo" centered hide-header>
    <modal-window :mainWidth="12">
      <div class="d-block">
        <h1>
          <i class="far fa-exclamation-triangle"></i>
          Unsaved changes
        </h1>
        <p>You have unsaved changes. Do you want to go back or discard the changes?</p>
      </div>
      <hr class="mt-3" />
      <div class="mt-3 d-flex justify-content-end">
        <button
          class="mr-2 btn btn-danger btn-sm"
          @click="
            $refs['unsavedValidModal'].hide();
            discardChanges();
          "
        >
          Discard changes and close
        </button>
        <button class="mr-2 btn btn-primary btn-sm" @click="$refs['unsavedValidModal'].hide()">Cancel</button>
      </div>
    </modal-window>
  </b-modal>

  <b-modal ref="unsavedInValidModal" hide-footer hide-header body-class="modal-body-wo" centered>
    <modal-window :main-width="12">
      <div class="d-block">
        <h1>
          <i class="far fa-exclamation-triangle"></i>
          Validation Error
        </h1>
        <p>
          Your input is not valid. Please fill the form correctly or return to the board if you do not want to create a new BoardItem.
        </p>
      </div>
      <hr class="mt-3" />
      <div class="mt-3 d-flex justify-content-end">
        <button class="mr-2 btn btn-danger btn-sm" @click="discardChanges()">
          Return to {{ metadata.occId ? 'Occurrence' : 'Board' }}
        </button>
        <button class="btn btn-primary btn-sm" @click="$refs['unsavedInValidModal'].hide()">Stay and fill</button>
      </div>
    </modal-window>
  </b-modal>

  <b-modal
    ref="sendAsEmailModal"
    id="sendAsEmailModal"
    hide-footer
    hide-header
    body-class="modal-body-wo"
    size="lg"
    :no-close-on-backdrop="true"
  >
    <send-as-email :item="item"></send-as-email>
  </b-modal>

  <b-modal
    ref="getBoardItemReport"
    id="getBoardItemReport"
    hide-footer
    hide-header
    body-class="modal-body-wo"
    size="lg"
    :no-close-on-backdrop="true"
  >
    <board-item-report :item="item"></board-item-report>
  </b-modal>
</div>
